module.exports = __webpack_public_path__ + "static/media/904ty@2x.3d11e513.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/904ty@2x.png
// module id = 1697
// module chunks = 0 1